/**
 * Paypal Express compatibility for ScandiPWA
 * @copyright Scandiweb, Inc. All rights reserved.
 */

export const ACCEPTANCE_MARK_POPUP_TITLE = 'olcwhatispaypal';
